import React, { createContext, useContext, useState, useEffect } from 'react'

export const PALETTES = [
  {
    id: 'dusty-blue',
    name: 'Støvet blågrå',
    tagline: 'Rolig, sofistikeret og nordisk',
    description: 'En blød skiferblå med tåget gråblå accent. Føles afbalanceret, nærværende og beroligende som morgendis over Svendborgsund. Giver klinikken et eksklusivt, harmonisk og varmt udtryk.',
    accent: '#7E97A6',
    primaryDark: '#3E4E59',
    sand: '#EDE8E1',
    offwhite: '#FAF8F5',
    gray: '#33373B',
    accentLight: '#E8EFF3',
    cardBg: '#F3EFE9',
    badge: 'Anbefalet test'
  },
  {
    id: 'light-petrol',
    name: 'Lys petroleum',
    tagline: 'Varmere, personlig og stadig rolig',
    description: 'En dybere, organisk havblå tone med en anelse varmere klang. Bevarer den trygge naturforbindelse fra grønne nuancer, men i en forfinet og personlig blålig retning, der virker utrolig imødekommende.',
    accent: '#6E969B',
    primaryDark: '#355359',
    sand: '#ECE7DF',
    offwhite: '#FAF8F5',
    gray: '#323839',
    accentLight: '#E6EFF0',
    cardBg: '#F2EDE5',
    badge: 'Mest varme'
  },
  {
    id: 'nordic-blue',
    name: 'Mild nordisk blå',
    tagline: 'Lys, ren og professionel',
    description: 'En mild fjord- og kystblå med lette, klare undertoner. Skaber en følelse af åndehul, overblik og lethed. Forbliver varm og terapeutisk i kombination med den bløde sand/creme bund og mørkegrå typografi.',
    accent: '#7B9DB5',
    primaryDark: '#384F63',
    sand: '#ECE7E0',
    offwhite: '#FAF8F5',
    gray: '#32363A',
    accentLight: '#E7F0F7',
    cardBg: '#F2ECE5',
    badge: 'Klar & let'
  },
  {
    id: 'classic-sage',
    name: 'Tidligere salviegrøn',
    tagline: 'Oprindelig grøn reference',
    description: 'Den hidtidige grønne farvepalette til hurtig sammenligning af før/efter-effekten.',
    accent: '#A8B7A1',
    primaryDark: '#50675A',
    sand: '#EFE7DD',
    offwhite: '#FAF8F5',
    gray: '#333333',
    accentLight: '#EEF2EC',
    cardBg: '#EFE7DD',
    badge: 'Tidligere grøn'
  }
]

const PaletteContext = createContext({
  palette: 'nordic-blue',
  setPalette: () => {},
  currentConfig: PALETTES[2],
  palettes: PALETTES
})

export function PaletteProvider({ children }) {
  const [palette, setPaletteState] = useState(() => {
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem('terapien_palette')
      if (saved && PALETTES.some(p => p.id === saved)) {
        if (saved === 'dusty-blue') return 'nordic-blue'
        return saved
      }
    }
    return 'nordic-blue'
  })

  useEffect(() => {
    document.documentElement.setAttribute('data-palette', palette)
    try {
      localStorage.setItem('terapien_palette', palette)
    } catch {
      // ignore
    }
  }, [palette])

  const setPalette = (id) => {
    if (PALETTES.some(p => p.id === id)) {
      setPaletteState(id)
    }
  }

  const currentConfig = PALETTES.find(p => p.id === palette) || PALETTES[0]

  return (
    <PaletteContext.Provider value={{ palette, setPalette, currentConfig, palettes: PALETTES }}>
      {children}
    </PaletteContext.Provider>
  )
}

export function usePalette() {
  return useContext(PaletteContext)
}
